enum Apps {
	TherapyEd = "therapyed",
	Psi = "psi",
	Jbjs = "jbjs",
	hiset = "hiset",
	toefl = "toefl",
	faa = "faa",
	cambridge = "cambridge",
	aavsb = "aavsb",
	cmaa = "cmaa",
	nascla = "nascla",
	wocncb = "wocncb",
}
export type AppIds =
	| "com.memorang.therapyed"
	| "com.memorang.psi.insurance"
	| "com.memorang.psi.insurance.testprep"
	| "org.ets.toeflpracticeaicoach"
	| "com.memorang.jbjs.image.challenge"
	| "com.memorang.jbjs"
	| "com.memorang.psi.aviation"
	| "com.memorang.cambridge.english.testprep"
	| "com.memorang.aavsb"
	| "com.memorang.psi.cmaa"
	| "com.memorang.nascla"
	| "com.memorang.psi.wocncb.testprep";

export { Apps };
